import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';

const PAGE_TITLES = {
  'embed-code': 'Embed Code',
  'my-sites': 'My Sites',
  scanner: 'Accessibility Monitor',
  'image-alts': 'Image Alts',
  'documents-and-pdfs': 'Documents and PDFs',
  'fix-my-code': 'Fix My Code',
  audits: 'Accessibility Services',
  vpat: 'Accessibility Services',
  compliance: 'Accessibility Services',
  legal: 'Accessibility Services',
  video: 'Accessibility Services',
  agency: 'Agency',
  regulation: 'Regulation tracker',
  map: 'Regulation tracker',
  overall: 'Regulation tracker',
  risk: 'Regulation tracker',
  enforcement: 'Regulation tracker',
  laws: 'Regulation tracker',
  team: 'Team',
  general: 'General',
  subscriptions: 'Subscriptions',
  'billing-invoices': 'Billing and Invoices',
  'add-sites': 'Add Sites',
  login: 'Login',
  registration: 'Registration',
  report: 'Report',
  overview: 'Overview',
  stats: 'Statistics',
  button: 'Button Configuration',
  appearance: 'Appearance',
  settings: 'Settings',
  configure: 'Configuration',
  widget: 'My sites',
};

@Injectable({
  providedIn: 'root',
})
export class PageTitleService {
  constructor(private titleService: Title) {}

  setPageTitle(url: string): void {
    const urlWithoutParams = url.split('?')[0];
    let route = urlWithoutParams.substring(urlWithoutParams.lastIndexOf('/') + 1);
    // Exception for pagination. Only My Sites page has params pagination.
    if (parseInt(route, 10)) {
      route = 'my-sites';
    }
    const title = PAGE_TITLES[route] ? PAGE_TITLES[route] + ' | UserWay' : 'UserWay Dashboard';
    this.titleService.setTitle(title);
  }
}
